var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsNotificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.023,
    height: 14.052,
    viewBox: "0 0 13.023 14.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_39-Notification",
    "data-name": "39-Notification",
    d: "M15.842,12.275a8.3,8.3,0,0,0-.5-.767,4.638,4.638,0,0,1-.918-1.941l-.211-2.959C14.087,4.317,12.748,2,10.086,2H8.972C6.31,2,4.961,4.317,4.825,6.6L4.615,9.567A4.7,4.7,0,0,1,3.7,11.528c-.17.261-.341.5-.456.727a1.113,1.113,0,0,0-.1,1.168,1.2,1.2,0,0,0,1.1.612H8.115a1.5,1.5,0,1,0,2.828,0h3.871a1.2,1.2,0,0,0,1.1-.632,1.073,1.073,0,0,0-.075-1.128ZM10.03,14.536a.5.5,0,1,1-.5-.5A.5.5,0,0,1,10.03,14.536Zm5.014-1.59c0,.04-.085.085-.211.085H4.244c-.125,0-.191-.045-.211-.085s0-.1.05-.176c.135-.231.291-.471.451-.712A5.261,5.261,0,0,0,5.613,9.637l.216-2.964C5.934,4.979,6.821,3,8.972,3h1.113c2.151,0,3.039,1.976,3.144,3.676l.216,2.959a5.1,5.1,0,0,0,1.1,2.422c.16.241.316.5.476.757A.125.125,0,0,1,15.045,12.947Z",
    transform: "translate(-3.02 -2)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsNotificationsIcon);
export default __webpack_public_path__ + "static/media/jobs-notifications-icon.3be805d0a4f0e67bc6d44f6f3fa25de2.svg";
export { ForwardRef as ReactComponent };